import {Injectable, OnDestroy} from '@angular/core';
import {CountryModel} from '../entity/country.model';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {CountryRepository} from '../../impl/service/ngrx/country.repository';
import {CountryDataServiceAdapter} from '../../impl/service/ngrx/countryDataService.adapter';

@Injectable()
export class CountryFindAllService extends AbstractFindAllService<CountryModel, CountryModel> implements OnDestroy{

    constructor(repository: CountryRepository, dataServiceAdapter: CountryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
